module.exports = __webpack_public_path__ + "img/bg.ae899196.jpeg";